import qs from "qs";

import { authFetch } from "utils";

const getAll = (start, end) =>
  authFetch(
    `${apiUrl}${version}/events/?${qs.stringify({
      start_date: start,
      end_date: end,
    })}`,
    {
      method: "GET",
    }
  );

export default getAll;
